export interface LevelReward {
    gems?: number;
    boost_days?: number;
    border_style?: string;
    border_name?: string;
}

export interface LevelConfig {
    level: number;
    xp_required: number;
    rewards?: LevelReward;
}

/**
 * Calculate XP required for a specific level.
 * Level 1: 0 XP
 * Level 2: 1000 XP
 * Level 3: 2100 XP (+1100)
 * Level 4: 3300 XP (+1200)
 * ...
 * The increment between levels increases by 100 XP each level starting from 1000.
 */
export function getXpForLevel(level: number): number {
    if (level <= 1) return 0;
    let totalXp = 0;
    let currentIncrement = 1000;
    for (let i = 2; i <= level; i++) {
        totalXp += currentIncrement;
        currentIncrement += 100;
    }
    return totalXp;
}

/**
 * Get the level for a given amount of XP.
 */
export function getLevelFromXp(xp: number): number {
    let level = 1;
    while (getXpForLevel(level + 1) <= xp) {
        level++;
    }
    return level;
}

/**
 * Configuration des récompenses par niveau.
 * Tu peux ajouter n'importe quel niveau ici (1, 2, 3, 4, etc.)
 */
export const LEVEL_REWARDS: Record<number, LevelReward> = {
    2: { boost_days: 1 },
    3: { border_style: 'wood_border' },
    4: { gems: 10 },
    5: { boost_days: 1 },
    6: { border_style: 'flowers_border' },
    7: { gems: 10 },
    8: { boost_days: 1 },
    9: { border_style: 'antic_border' },
    11: { gems: 15 },
    12: { boost_days: 1 },
    13: { border_style: 'scifi_border' },
    14: { gems: 15 },
    15: { boost_days: 1 },
    16: { border_style: 'sword_border' },
    17: { gems: 20 },
    18: { boost_days: 1 },
    19: { border_style: 'oniric_border' },
    20: { gems: 20 },
    21: { boost_days: 1 },
    22: { border_style: 'japan_border' },
    23: { gems: 25 },
    24: { boost_days: 1 },
    25: { gems: 25 },
    26: { gems: 25 },
    27: { boost_days: 1 },
    28: { gems: 25 },
    29: { gems: 25 },
    30: { boost_days: 1 },
    31: { gems: 25 },
    32: { gems: 25 },
    33: { boost_days: 1 },
    34: { gems: 25 },
    35: { gems: 25 },
    36: { boost_days: 1 },
    37: { gems: 25 },
    38: { gems: 25 },
    39: { boost_days: 1 },
    40: { gems: 25 },
    41: { gems: 25 },
    42: { boost_days: 1 },
    43: { gems: 25 },
    44: { gems: 25 },
    45: { boost_days: 1 },
    46: { gems: 25 },
    47: { gems: 25 },
    48: { boost_days: 1 },
    49: { gems: 25 },
    50: { gems: 25 },
    51: { boost_days: 1 },
    52: { gems: 25 },
    53: { gems: 25 },
    54: { boost_days: 1 },
    55: { gems: 25 },
    56: { gems: 25 },
    57: { boost_days: 1 },
    58: { gems: 25 },
    59: { gems: 25 },
    60: { boost_days: 1 },
    61: { gems: 25 },
    62: { gems: 25 },
    63: { boost_days: 1 },
    64: { gems: 25 },
    65: { gems: 25 },
    66: { boost_days: 1 },
    67: { gems: 25 },
    68: { gems: 25 },
    69: { boost_days: 1 },
    70: { gems: 25 },
    71: { gems: 25 },
    72: { boost_days: 1 },
    73: { gems: 25 },
    74: { gems: 25 },
    75: { boost_days: 1 },
    76: { gems: 25 },
    77: { gems: 25 },
    78: { boost_days: 1 },
    79: { gems: 25 },
    80: { gems: 25 },
    81: { boost_days: 1 },
    82: { gems: 25 },
    83: { gems: 25 },
    84: { boost_days: 1 },
    85: { gems: 25 },
    86: { gems: 25 },
    87: { boost_days: 1 },
    88: { gems: 25 },
    89: { gems: 25 },
    90: { boost_days: 1 },
    91: { gems: 25 },
    92: { gems: 25 },
    93: { boost_days: 1 },
    94: { gems: 25 },
    95: { gems: 25 },
    96: { boost_days: 1 },
    97: { gems: 25 },
    98: { gems: 25 },
    99: { boost_days: 1 },
    100: { gems: 25 },
};

/**
 * Get rewards for a specific level.
 */
export function getLevelRewards(level: number): LevelReward | null {
    return LEVEL_REWARDS[level] || null;
}
